if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          (element) => {
            // For regular variant options (radio buttons/swatches)
            if (element.dataset.optionValueId) {
              return element.dataset.optionValueId;
            }
            // For nested products
            if (element.dataset.productId) {
              return element.dataset.productId;
            }
            // Fallback to value if there's no specific dataset
            return element.value;
          }
        ).filter(value => value); // Filter undefined/null/empty values
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {

        this.querySelectorAll('input').length > 0 && this.querySelectorAll('input').forEach(input => {
          input.addEventListener('click', (event) => {
            if (input.classList.contains('checked')) {
              input.checked = false;
              input.classList.remove('checked');
            } else {
              input.parentElement.querySelector('input.checked')?.classList.remove('checked');
              input.classList.add('checked');
            }
            this.changeHandler(event);
          });
        });

        this.addEventListener('change', (event) => this.changeHandler(event));
        
        // Add click handlers for nested product radio buttons
        this.addEventListener('click', (event) => {
          this.handleNestedProductClick(event);
        });
      }

      changeHandler(event) {
        const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValue: target.value,
            },
          });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
      
      handleNestedProductClick(event) {
        const label = event.target.closest('label') || event.target;
        if (!label || !label.getAttribute('for')) return;
        
        const input = document.getElementById(label.getAttribute('for'));
        if (!input || input.name !== 'nested_product_option' || !input.dataset.productUrl) return;
        
        // Navigate to product without URL parameters
        window.location.href = input.dataset.productUrl;
      }
    }
  );
}
